import React, { useContext } from 'react';

import * as S from './styles';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import { DataFormProps } from 'types/InputsProductCarouselProps';
import ScheduleInfoDynamicPage from 'components/ScheduleInfoDynamicPage';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
import TypeStoreContext from 'context/TypeStoreContext';
import CarrosselProductsScreenStatics from 'components/CarrosselProductsScreenStatics';
// import Default from './interfaces/Default';
// import Fashion from './interfaces/Fashion';
// import Grocery from './interfaces/Grocery';

interface ProductCarouselProps {
	item: ItemDynamicPageInPhone;
}

export default function ProductCarousel({ item }: ProductCarouselProps) {
	const { data } = item;
	const { typeStore } = useContext(TypeStoreContext);

	const productsData: DataFormProps = data;

	function returnInterfaceByTypeStore() {
		switch (typeStore) {
			case 'default':
				return (
					<CarrosselProductsScreenStatics query={data?.reference_id || ''} />
				);

			case 'grocery':
				return (
					<CarrosselProductsScreenStatics query={data?.reference_id || ''} />
				);

			case 'fashion':
				return (
					<CarrosselProductsScreenStatics query={data?.reference_id || ''} />
				);

			default:
				return (
					<CarrosselProductsScreenStatics query={data?.reference_id || ''} />
				);
		}
	}

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container>
			{(productsData.schedule_start !== '' ||
				productsData.schedule_end !== '') && (
				<ScheduleInfoDynamicPage
					countdown={productsData.countdown}
					endDate={productsData.schedule_end}
					startDate={productsData.schedule_start}
				/>
			)}
			{returnInterfaceByTypeStore()}
		</S.container>
	);
}
